import { Disclosure } from '@headlessui/react'
import Tippy from '@tippyjs/react'
import { Fragment } from 'react'
import StakingItemCountDown from './StakingItemCountDown'
import { numberWithCommasNormal } from '../../utils/utils'
import Link from 'next/link'

const convertStatusText = (status) => {
  if (status === 'READY') {
    return 'Ready'
  } else if (status === 'IN_PROGRESS_STAKING') {
    return 'Staking'
  } else if (status === 'IN_PROGRESS_DEPOSIT') {
    return 'Deposit'
  } else {
    return 'Ended'
  }
}

const StakingTable = ({
  stakingPrograms,
  myStakingPrograms,
  handelClaim,
  handelStaking,
  handelUnStaking,
  handelViewSchedule,
  isLogin,
}) => {
  return stakingPrograms ? (
    <>
      {stakingPrograms.map((program) => {
        const myStakingProgram = myStakingPrograms
          ? myStakingPrograms.find((f) => f.earlyStakingProgramExternalId === program.externalId)
          : undefined

        let baseTokenImageUrl = ''
        let rewardTokenImageUrl = ''
        if (program.depositToken === 'WKM') {
          baseTokenImageUrl = 'https://ad-banner.walkmining.com/web/ic_coin_wkm.png'
        } else if (program.depositToken === 'WKG') {
          baseTokenImageUrl = 'https://ad-banner.walkmining.com/web/ic_coin_wkg.png'
        }

        if (program.rewardToken === 'WKM') {
          rewardTokenImageUrl = 'https://ad-banner.walkmining.com/web/ic_coin_wkm.png'
        } else if (program.rewardToken === 'WKG') {
          rewardTokenImageUrl = 'https://ad-banner.walkmining.com/web/ic_coin_wkg.png'
        }

        return (
          <Disclosure key={program.externalId}>
            <Disclosure.Button as={Fragment}>
              <div className="flex flex-wrap h-[80px] border-t border-jacarta-100 transition-shadow hover:shadow-lg dark:border-jacarta-600 dark:bg-jacarta-900 cursor-pointer">
                <div
                  className="flex w-[40%] py-2 px-4 relative items-center justify-start truncate md:w-[15%]"
                  role="cell"
                >
                  {program.ribbonText && (
                    <div className="absolute left-0 top-0 z-10 flex items-center">
                      <div className="absolute transform -rotate-45 bg-jacarta-600 text-center text-white -left-[23px] top-[14px] w-[90px] text-[12px] leading-[16px] pb-[2px] ">
                        {program.ribbonText}
                      </div>
                    </div>
                  )}
                  <img className="w-10 z-0" src={rewardTokenImageUrl} />
                  <img className="w-6 z-10 -ml-5 pt-7" src={baseTokenImageUrl} />
                  <div className="text-left">
                    {myStakingProgram && <span className="block text-[12px] text-accent ml-2">STAKED</span>}
                    <span className="block text-[15px] text-jacarta-700 dark:text-white ml-2">
                      Earn {program.rewardToken}
                    </span>
                    <span className="ml-2 text-[11px] text-jacarta-400">Stake {program.depositToken}</span>
                  </div>
                </div>
                <div
                  className="hidden w-[15%] relative items-center text-left justify-start truncate md:flex"
                  role="cell"
                >
                  <div className="text-left">
                    <div className="block text-[12px] text-jacarta-400 dark:text-white ml-2">
                      {program.rewardToken} Earned
                    </div>
                    <div
                      className={`ml-2 text-sm ${
                        myStakingProgram && myStakingProgram.rewardAmount > 0
                          ? 'text-jacarta-700 dark:text-white'
                          : 'text-jacarta-300'
                      }`}
                    >
                      {myStakingProgram && myStakingProgram.rewardAmount > 0 && program.status === 'IN_PROGRESS_STAKING'
                        ? `≈ ${numberWithCommasNormal(myStakingProgram.rewardAmount)}`
                        : '0.0'}
                    </div>
                  </div>
                </div>
                <div className="hidden w-[15%] items-center justify-start text-right md:flex" role="cell">
                  <div className="text-left">
                    <div className="block text-[12px] text-jacarta-400 dark:text-white ml-2">Total staked</div>
                    <div className="ml-2 text-sm text-jacarta-700 dark:text-jacarta-200">
                      {numberWithCommasNormal(program.depositAmount)}
                      <span className="text-[9px] text-jacarta-300">{program.depositToken}</span>
                    </div>
                  </div>
                </div>
                <div className="hidden w-[20%] items-center justify-start text-right md:flex" role="cell">
                  <div className="text-left">
                    <div className="block text-[12px] text-jacarta-400 dark:text-white ml-2">Claimed reward</div>
                    <div
                      className={`ml-2 text-sm ${
                        myStakingProgram && program.status === 'IN_PROGRESS_STAKING'
                          ? 'text-jacarta-700 dark:text-jacarta-200'
                          : 'text-jacarta-300'
                      }`}
                    >
                      {myStakingProgram && program.status === 'IN_PROGRESS_STAKING'
                        ? `${numberWithCommasNormal(myStakingProgram.claimAmount)}${program.rewardToken}`
                        : '0.0'}
                    </div>
                  </div>
                </div>
                <div className="flex w-[30%] items-center justify-start text-right md:w-[25%]" role="cell">
                  <div className="text-left">
                    <div className="flex items-center justify-start text-[12px] text-jacarta-400 dark:text-white ml-2">
                      {program.status === 'IN_PROGRESS_STAKING' && 'Ends in'}
                      {program.status === 'IN_PROGRESS_DEPOSIT' && 'Deposit Ends in'}
                      {program.status === 'READY' && 'Start in'}
                      {program.status === 'ENDED' && 'Status'}
                      <Tippy
                        content={
                          <div className="bg-jacarta-700 text-white text-sm p-3">
                            {(program.status === 'IN_PROGRESS_STAKING' || program.status === 'ENDED') && (
                              <>
                                Staking End Time:
                                <br />
                                {program.stakingEndDateTime}(UTC)
                              </>
                            )}
                            {program.status === 'IN_PROGRESS_DEPOSIT' && (
                              <>
                                Deposit End Time:
                                <br />
                                {program.depositEndDateTime}(UTC)
                              </>
                            )}
                            {program.status === 'READY' && (
                              <>
                                Deposit Start:
                                <br />
                                {program.depositStartDateTime}(UTC)
                              </>
                            )}
                          </div>
                        }
                      >
                        <span className="ml-1 mt-0.5">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width={24}
                            height={24}
                            className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-300"
                          >
                            <path fill="none" d="M0 0h24v24H0z" />
                            <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" />
                          </svg>
                        </span>
                      </Tippy>
                    </div>
                    <div className="flex justify-between ml-2 text-sm text-jacarta-600 dark:text-jacarta-200">
                      {(program.status === 'IN_PROGRESS_STAKING' ||
                        program.status === 'IN_PROGRESS_DEPOSIT' ||
                        program.status === 'READY') && (
                        <StakingItemCountDown time={program.countDownMillisecond} simple={true} />
                      )}
                      {program.status === 'ENDED' && 'Finsh'}
                    </div>
                  </div>
                </div>
                <div
                  className="flex w-[30%] items-center justify-end text-right md:w-[10%] py-2 px-4"
                  role="columnheader"
                >
                  <div className="hidden py-2 items-center md:flex text-accent">
                    <span className="block ui-open:hidden">Details </span>
                    <span className="hidden ui-open:block">Hide </span>
                    <span className="inline-block">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        color="primary"
                        width="24px"
                        className="rotate-0 fill-accent ui-open:rotate-180"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M8.11997 9.29006L12 13.1701L15.88 9.29006C16.27 8.90006 16.9 8.90006 17.29 9.29006C17.68 9.68006 17.68 10.3101 17.29 10.7001L12.7 15.2901C12.31 15.6801 11.68 15.6801 11.29 15.2901L6.69997 10.7001C6.30997 10.3101 6.30997 9.68006 6.69997 9.29006C7.08997 8.91006 7.72997 8.90006 8.11997 9.29006Z"></path>
                      </svg>
                    </span>
                  </div>
                  <div className="flex py-2 items-center md:hidden">
                    <span className="inline-block">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        color="primary"
                        width="24px"
                        className="rotate-0 fill-accent ui-open:rotate-180"
                      >
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M8.11997 9.29006L12 13.1701L15.88 9.29006C16.27 8.90006 16.9 8.90006 17.29 9.29006C17.68 9.68006 17.68 10.3101 17.29 10.7001L12.7 15.2901C12.31 15.6801 11.68 15.6801 11.29 15.2901L6.69997 10.7001C6.30997 10.3101 6.30997 9.68006 6.69997 9.29006C7.08997 8.91006 7.72997 8.90006 8.11997 9.29006Z"></path>
                      </svg>
                    </span>
                  </div>
                </div>
              </div>
            </Disclosure.Button>
            <Disclosure.Panel className="text-jacarta-500">
              <div
                className="flex flex-wrap justify-start border-t border-jacarta-100 py-2 px-4 transition-shadow hover:shadow-lg dark:border-jacarta-600 dark:bg-jacarta-700 bg-jacarta-50"
                role="row"
              >
                <div className="w-full">
                  <div className="overflow-hidden w-full">
                    <div className="items-center w-full lg:flex">
                      <div className="basis-1/3">
                        <div className="flex justify-between pr-6">
                          <span className="flex items-center justify-center text-jacarta-400 text-[11px]">
                            Total Staked
                            <Tippy
                              content={
                                <div className="bg-jacarta-700 text-white text-sm p-3">
                                  Total staked ${program.depositToken} of WalkMiners
                                </div>
                              }
                            >
                              <span className="ml-1 mt-0.5">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width={24}
                                  height={24}
                                  className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-300"
                                >
                                  <path fill="none" d="M0 0h24v24H0z" />
                                  <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" />
                                </svg>
                              </span>
                            </Tippy>
                          </span>
                          <span className="ml-12 text-sm font-medium text-jacarta-700 dark:text-white">
                            {numberWithCommasNormal(program.depositAmount)}
                            {program.status === 'READY' ||
                              (program.status === 'IN_PROGRESS_DEPOSIT' &&
                                `/${numberWithCommasNormal(program.maxDepositAmount)}`)}
                            <span className="text-[9px] text-jacarta-300">{program.depositToken}</span>
                          </span>
                        </div>
                        <div className="flex justify-between pr-6 pt-2">
                          <span className="flex items-center justify-center text-jacarta-400 text-[11px]">
                            Claiming Cycle
                            <Tippy
                              content={
                                <div className="bg-jacarta-700 text-white text-sm p-2">
                                  daily, weekly, monthly basis
                                </div>
                              }
                            >
                              <span className="ml-1 mt-0.5">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width={24}
                                  height={24}
                                  className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-300"
                                >
                                  <path fill="none" d="M0 0h24v24H0z" />
                                  <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" />
                                </svg>
                              </span>
                            </Tippy>
                          </span>
                          <span className="float-right ml-12 text-sm font-medium text-jacarta-700 dark:text-white">
                            {program.rewardCycle === 'DAY' && 'Daily'} {program.rewardCycle === 'WEEK' && 'Week'}{' '}
                            {program.rewardCycle === 'MONTH' && 'Month'}
                          </span>
                        </div>
                        <div className="flex justify-between pr-6 pt-2">
                          <span className="flex items-center justify-center text-jacarta-400 text-[11px]">
                            Claimed Reward
                            <Tippy
                              content={
                                <div className="bg-jacarta-700 text-white text-sm p-3">Earned reward amount</div>
                              }
                            >
                              <span className="ml-1 mt-0.5">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 24 24"
                                  width={24}
                                  height={24}
                                  className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-300"
                                >
                                  <path fill="none" d="M0 0h24v24H0z" />
                                  <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" />
                                </svg>
                              </span>
                            </Tippy>
                          </span>
                          <span
                            className={`flex float-right ml-12 text-sm font-medium ${
                              myStakingProgram && program.status === 'IN_PROGRESS_STAKING'
                                ? 'text-jacarta-700 dark:text-white'
                                : 'text-jacarta-300'
                            }`}
                          >
                            {myStakingProgram && program.status === 'IN_PROGRESS_STAKING'
                              ? `${numberWithCommasNormal(myStakingProgram.claimAmount)}${program.rewardToken}`
                              : '0.0'}
                          </span>
                        </div>
                        <div className="flex justify-between pr-6 pt-2">
                          <span className="text-jacarta-400 text-[11px]">Status</span>
                          <span className="float-right ml-12 text-sm font-medium text-jacarta-700 dark:text-jacarta-200">
                            {convertStatusText(program.status)}
                          </span>
                        </div>
                        {program.status != 'ENDED' && (
                          <div className="justify-between pr-6 pt-2">
                            <span className="text-jacarta-400 text-[11px]">
                              {program.status === 'READY' && 'Start in'}
                              {program.status === 'IN_PROGRESS_STAKING' && 'Staking Ended in'}
                              {program.status === 'IN_PROGRESS_DEPOSIT' && 'Deposit Ended in'}
                            </span>
                            <span className="float-right ml-12 text-sm font-medium text-jacarta-700">
                              {(program.status === 'IN_PROGRESS_STAKING' ||
                                program.status === 'IN_PROGRESS_DEPOSIT' ||
                                program.status === 'READY') && (
                                <StakingItemCountDown time={program.countDownMillisecond} simple={false} />
                              )}
                            </span>
                          </div>
                        )}
                        <div className="flex items-center justify-center mt-2">
                          <div
                            href="https://docs.walkmining.com/product/staking"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-accent dark:hover:text-white inline-block mt-3 mr-6 cursor-pointer dark:text-jacarta-200"
                            onClick={() => {
                              handelViewSchedule(program.externalId)
                            }}
                          >
                            View Schedule{' '}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              className="w-4 inline-block"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25"
                              />
                            </svg>
                          </div>
                          <a
                            href="https://docs.walkmining.com/product/staking"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-accent dark:hover:text-white inline-block mt-3 dark:text-jacarta-200"
                          >
                            View Guide{' '}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth="1.5"
                              stroke="currentColor"
                              className="w-4 inline-block"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                      <div className="basis-2/3 lg:flex">
                        <div className="flex min-h-full items-center justify-center p-4 text-center basis-1/2">
                          <div className="flex flex-col items-start w-full h-[150px] transform rounded-2xl bg-white p-6 text-left align-middle transition-all">
                            <div className="flex items-center justify-center text-[13px] leading-6 text-jacarta-700">
                              <span className="text-accent-light font-bold pr-1">{program.rewardToken}</span>EARNED
                              <Tippy
                                content={
                                  <div className="bg-jacarta-700 text-white text-sm p-3">
                                    Rewards that can be claimed immediately
                                  </div>
                                }
                              >
                                <span className="ml-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width={24}
                                    height={24}
                                    className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-300"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" />
                                  </svg>
                                </span>
                              </Tippy>
                            </div>
                            <div className="flex items-center h-full w-full">
                              <p
                                className={`text-xl ${
                                  myStakingProgram && myStakingProgram.rewardAmount > 0
                                    ? 'text-jacarta-700'
                                    : 'text-jacarta-300'
                                } w-[70%]`}
                              >
                                ≈ {myStakingProgram ? numberWithCommasNormal(myStakingProgram.rewardAmount) : '0.0'}
                              </p>
                              <button
                                disabled={myStakingProgram && myStakingProgram.rewardAmount > 0 ? false : true}
                                className={`w-[30%] h-10 rounded-lg border-spacing-1 ${
                                  myStakingProgram && myStakingProgram.rewardAmount > 0
                                    ? 'bg-jacarta-700'
                                    : 'bg-jacarta-300'
                                } justify-end hover:bg-jacarta-600 text-[14px] text-jacarta-100`}
                                onClick={() => {
                                  handelClaim(program.externalId)
                                }}
                              >
                                Harvest
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="flex min-h-full items-center justify-center p-4 text-center basis-1/2">
                          <div className="flex flex-col items-start w-full h-[150px] transform rounded-2xl bg-white p-6 text-left align-middle transition-all">
                            <div className="flex items-center justify-center text-[13px] font-medium leading-6 text-jacarta-700">
                              <span className="text-accent-light font-bold pr-1">{program.depositToken}</span>STAKED
                              <Tippy
                                content={
                                  <div className="bg-jacarta-700 text-white text-sm p-3">
                                    Amount of tokens currently being staked (locked)
                                  </div>
                                }
                              >
                                <span className="ml-1">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width={24}
                                    height={24}
                                    className="h-4 w-4 fill-jacarta-500 dark:fill-jacarta-300"
                                  >
                                    <path fill="none" d="M0 0h24v24H0z" />
                                    <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM11 7h2v2h-2V7zm0 4h2v6h-2v-6z" />
                                  </svg>
                                </span>
                              </Tippy>
                            </div>
                            {!isLogin ? (
                              <div className="flex items-center text-center w-full h-full">
                                <Link
                                  className="flex justify-center items-center w-full h-12 hover:bg-jacarta-600 text-[16px] rounded-full bg-[#131740] text-white"
                                  href={'/login?ref=/staking'}
                                >
                                  Sign in
                                </Link>
                              </div>
                            ) : (
                              <div className="flex items-center h-full w-full">
                                <p
                                  className={`text-xl ${
                                    myStakingProgram && myStakingProgram.depositAmount > 0
                                      ? 'text-jacarta-700'
                                      : 'text-jacarta-300'
                                  } w-[70%]`}
                                >
                                  {myStakingProgram ? numberWithCommasNormal(myStakingProgram.depositAmount) : '0.0'}
                                  {myStakingProgram && myStakingProgram.depositAmount > 0 && (
                                    <div className="text-jacarta-300 text-[13px]">
                                      Share ratio{' '}
                                      {myStakingProgram.shareRate > 0 ? `${myStakingProgram.shareRate}%` : '< 1%'}
                                    </div>
                                  )}
                                </p>
                                {myStakingProgram &&
                                  program.status === 'ENDED' &&
                                  myStakingProgram.depositAmount > 0 && (
                                    <>
                                      <button
                                        className="flex justify-center items-center w-full h-12 hover:bg-jacarta-600 text-[16px] rounded-full bg-[#131740] text-white"
                                        onClick={() => {
                                          handelUnStaking(program.externalId)
                                        }}
                                      >
                                        Unstake
                                      </button>
                                    </>
                                  )}
                                {program.status === 'IN_PROGRESS_DEPOSIT' ? (
                                  myStakingProgram && myStakingProgram.depositAmount > 0 ? (
                                    <>
                                      <button
                                        className={`flex items-center w-[30%] h-10 rounded-lg border border-jacarta-700 justify-center hover:bg-jacarta-100 text-[20px] text-jacarta-700`}
                                        onClick={() => {
                                          handelStaking(program.externalId)
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          strokeWidth={1.5}
                                          stroke="currentColor"
                                          className="w-4 h-4"
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 4.5v15m7.5-7.5h-15"
                                          />
                                        </svg>
                                      </button>
                                      <button
                                        className={`flex items-center justify-center w-[30%] h-10 rounded-lg border border-red hover:bg-jacarta-100 text-[20px] text-jacarta-700 ml-1`}
                                        onClick={() => {
                                          handelUnStaking(program.externalId)
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          strokeWidth={1.5}
                                          stroke="currentColor"
                                          className="w-3 h-4 text-red"
                                        >
                                          <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12h-15" />
                                        </svg>
                                      </button>
                                    </>
                                  ) : (
                                    <button
                                      className="flex justify-center items-center w-full h-12 hover:bg-jacarta-600 text-[16px] rounded-full bg-[#131740] text-white"
                                      onClick={() => {
                                        handelStaking(program.externalId)
                                      }}
                                    >
                                      Staking
                                    </button>
                                  )
                                ) : program.status != 'ENDED' &&
                                  myStakingProgram &&
                                  myStakingProgram.depositAmount > 0 ? (
                                  <div
                                    className={`w-[30%] h-10 rounded-lg border-spacing-1 justify-end text-jacarta-500 text-lg cursor-pointer`}
                                  >
                                    <Tippy
                                      content={
                                        <div className="text-[13px] p-3 bg-jacarta-700 text-white">
                                          Unlock {program.claimStartDateTime}(UTC) ~
                                        </div>
                                      }
                                    >
                                      <span>Locked</span>
                                    </Tippy>
                                  </div>
                                ) : null}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Disclosure.Panel>
          </Disclosure>
        )
      })}
    </>
  ) : (
    <></>
  )
}

export default StakingTable
